import { FC } from 'react';
import { DataCellProps } from '../types';

export const TeamMemberIsActiveCell: FC<DataCellProps> = ({ _customRowProps, member }) => {
  return <div>{member.is_active ? 'Active' : ''}</div>;
};
